module.exports = __webpack_public_path__ + "static/media/google-play-badge.5d9a073b.png";